import { Typography } from '@arionbanki/arionui';
import { useState } from 'react';
import { AdminDrawer } from './AdminDrawer';
import { AdminFilters } from './AdminFilters';
import { AdminPrefsBar, BulkToggleButton } from './AdminPrefsBar';
import { AdminTable } from './AdminTable';
import { AdminTabs } from './AdminTabs';
import { BulkCancel } from './BulkCancel';
import { ScrollTopButton } from './ScrollTopButton';
import { useAdmin } from './useAdmin';
import { useAdminPrefs } from './useAdminPrefs';

export function Admin() {
	const { data, t, ...ctx } = useAdmin();
	const { density, showGuid, toggleDensity, toggleShowGuid } = useAdminPrefs();
	const [view, setView] = useState<'processes' | 'bulk'>('processes');
	const isBulk = view === 'bulk';
	const toggleView = () => setView(isBulk ? 'processes' : 'bulk');
	const drawerRow = ctx.drawerRow;

	if (isBulk) {
		return (
			<div className={`admin-dashboard admin-dashboard--${density}`}>
				<div className="admin-dashboard__header">
					<Typography TagName="h3">{t('admin_title')}</Typography>
					<div className="admin-prefs-bar">
						<div className="admin-prefs-toggles">
							<BulkToggleButton isBulk={isBulk} onToggle={toggleView} t={t} />
						</div>
					</div>
				</div>
				<BulkCancel />
			</div>
		);
	}

	return (
		<>
			<div className={`admin-dashboard admin-dashboard--${density}`}>
				<div className="admin-dashboard__header">
					<Typography TagName="h3">{t('admin_title')}</Typography>
					<AdminPrefsBar
						density={density}
						isBulk={isBulk}
						onToggleBulk={toggleView}
						resultCount={data.length}
						showGuid={showGuid}
						t={t}
						toggleDensity={toggleDensity}
						toggleShowGuid={toggleShowGuid}
						totalCount={ctx.totalCount}
					/>
				</div>

				<AdminTabs setBucket={ctx.setBucket} tabs={ctx.tabs} />

				<AdminFilters {...ctx} t={t} />

				<div className="admin-dashboard__messages">
					{ctx.isLoading && (
						<div aria-live="polite" className="admin-loading" role="status">
							<span className="admin-loading__spinner" />
							<Typography TagName="p">{t('loading')}</Typography>
						</div>
					)}
					{ctx.error && <Typography TagName="p">{t('error')}</Typography>}
				</div>

				<AdminTable {...ctx} data={data} showGuid={showGuid} t={t} />
			</div>

			{drawerRow && <AdminDrawer onClose={ctx.closeDrawer} onRefresh={ctx.refreshData} row={drawerRow} />}
			<ScrollTopButton />
		</>
	);
}
